import { FC } from 'react'
import PublishSwitch from '@components/PublishSwitch'
import { PublishActionProps } from '../../types'

const PublishAction: FC<PublishActionProps> = props => {
  const { resourceId, resourceType, entity } = props
  return <PublishSwitch resourceId={Number(resourceId)} resourceType={resourceType} entity={entity} />
}

export default PublishAction
